import axios from 'axios';

let url = '';

export const initSimulationsService = (config: Record<string, any>) => {
    url = config.simulationsURL;
};

export const getAllSimulations = async () => {
    const res = await axios.get(`${url}`);
    return res.data;
};

export const getSimulationById = async (id: number) => {
    const res = await axios.get(`${url}/${id}`);
    return res.data;
};

export const postSimulation = async (data: PostSimulationObject) => {
    const res = await axios.post(`${url}`, data);
    return res.data;
};

export const getLastMinuteSimulations = async (customDuration?: number) => {
    const res = await axios.get(`${url}/status-updates`, { params: { customDuration } });
    return res.data;
};

export const getSimulationReportCSV = (rid: number) => {
    return axios.get(`${url}/csv/${rid}`, {
        responseType: 'blob'
    });
};

export const deleteSingleSimulation = (id: number) => {
    return axios.delete(`${url}/${id}`);
};
